import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';
import NoData from '@components/NoData';

import EditButton from '@features/supplier/component/EditButton';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getSuppliersDetails } from '@store/reducers';
import { fetchSupplierDetails } from '@store/supplier/action';

import { onUpdateSpecification } from '@services/supplierService';

const Technical = () => {
	const [isEdit, setIsEdit] = useState(false);
	const [technical, setTechnical] = useState(null);
	const supplierDetails = useSelector(getSuppliersDetails);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		setTechnical(supplierDetails?.factoryInfo);
	}, [supplierDetails]);

	const TechnicalItem = ({ iconSrc, title, property }) => {
		return (
			<div
				className={`single same-padding-box cursor-pointer text-center ${
					technical[property] ? 'selected' : ''
				}`}
				onClick={() =>
					isEdit
						? setTechnical((prevTechnical) => ({
								...prevTechnical,
								[property]: !prevTechnical[property]
							}))
						: null
				}
			>
				<div className="technical-img">
					<img src={iconSrc} alt="box" />
				</div>
				<h3 className="title regular-18 gray_dark_01 font-weight-normal mt-1">{title}</h3>
			</div>
		);
	};

	const technicalItemsData = [
		{ iconSrc: process.env.PUBLIC_URL + '/icons/rd.svg', title: 'R&D', property: 'haveRnd' },
		{ iconSrc: process.env.PUBLIC_URL + '/icons/lab.svg', title: 'Lab', property: 'haveLab' },
		{ iconSrc: process.env.PUBLIC_URL + '/icons/studio.svg', title: 'Studio', property: 'haveStudio' },
		{ iconSrc: process.env.PUBLIC_URL + '/icons/sample.png', title: 'Sample', property: 'haveSample' },
		{
			iconSrc: process.env.PUBLIC_URL + '/icons/composite.svg',
			title: 'Composite',
			property: 'isComposite'
		},
		{ iconSrc: process.env.PUBLIC_URL + '/icons/etp.svg', title: 'ETP', property: 'haveEtp' },
		{ iconSrc: process.env.PUBLIC_URL + '/icons/etp.svg', title: 'WTP', property: 'haveWtp' }
	];

	const onSubmit = async () => {
		try {
			dispatch(openLoader());
			const response = await onUpdateSpecification(id, { factoryInfo: technical });
			if (response) {
				dispatch(fetchSupplierDetails(id));
				dispatch(closeLoader());
				setIsEdit(false);
			}
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<div className="technical-section section-padding hover-section">
			<h3 className="suplier-title pb-4 font-weight-bold regular-16">
				Technical
				<EditButton onEditClick={() => setIsEdit(true)} />
			</h3>

			{supplierDetails?.factoryInfo && Object.keys(supplierDetails?.factoryInfo)?.length === 0 ? (
				<NoData message="No Technicalities added" />
			) : (
				<div className="technical-items">
					{technical &&
						technicalItemsData
							?.filter((item) => supplierDetails?.factoryInfo[item.property])
							.map((item, index) => <TechnicalItem key={index} {...item} />)}
				</div>
			)}

			{isEdit && (
				<ModalContainer>
					<div className="common-popup technical-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Technical</h3>
							</div>
							<div className="close-btn" onClick={() => setIsEdit(false)}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>
						<div className="common-popup-body">
							{[
								{ items: technicalItemsData.slice(0, 4), className: '' },
								{ items: technicalItemsData.slice(4, 7), className: 'technical-items-bottom' }
							].map((section, sectionIndex) => (
								<div key={sectionIndex} className={`technical-items ${section.className}`}>
									{section.items.map((item, itemIndex) => (
										<TechnicalItem key={itemIndex} {...item} />
									))}
								</div>
							))}
						</div>

						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button
									className="button gray-outline size32 ml-2"
									onClick={() => setIsEdit(false)}
								>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={onSubmit}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</ModalContainer>
			)}
		</div>
	);
};

export default Technical;
